import { ACTIVE, FIRSTNAME, LASTNAME, USERNAME } from "../../../ducks/userManagement";
import { FormattedMessage } from "react-intl";
import React, { useMemo } from "react";

import PropTypes from "prop-types";
import SurveyUtils from "../../../utils/SurveyUtils";
import BootstrapTable from "react-bootstrap/Table";
import { USER_EDITOR } from "../../../common/constant";
import UserManagementTableRow from "./UserManagementTableRow";
import Visibility from "../../../component/common/VisibleContainer";
import { Button } from "react-bootstrap";

const UserManagementTable = ({
  sortUserTableBy,
  prepareUserDataForEditing,
  propertyChange,
  locale,
  sendUserAccountNotification,
  users,
  sortUserTableOrder,
  usersParticipations,
  loadUsers,
  changeSortingProperties,
  onSort
}) => {
  const onSortTable = (columnName) => {
    if (onSort) {
      onSort();
    }
    if (sortUserTableBy === columnName) {
      changeSortingProperties(columnName, sortUserTableOrder === "asc" ? "desc" : "asc");
      loadUsers();
    } else {
      changeSortingProperties(columnName, "asc");
      loadUsers();
    }
  };

  const orderAscending = sortUserTableOrder === "asc";

  return (
    <BootstrapTable responsive>
      <thead>
        <tr>
          <th className={SurveyUtils.addClassForTableHeader(USERNAME, sortUserTableBy, orderAscending)}>
            <Button variant="link" onClick={() => onSortTable(USERNAME)}>
              <FormattedMessage id="user.management.table.username" />
              {SurveyUtils.sortIcon(USERNAME, sortUserTableBy, orderAscending)}
            </Button>
          </th>
          <th className={SurveyUtils.addClassForTableHeader(FIRSTNAME, sortUserTableBy, orderAscending)}>
            <Button variant="link" onClick={() => onSortTable(FIRSTNAME)}>
              <FormattedMessage id="user.management.table.firstname" />
              {SurveyUtils.sortIcon(FIRSTNAME, sortUserTableBy, orderAscending)}
            </Button>
          </th>
          <th className={SurveyUtils.addClassForTableHeader(LASTNAME, sortUserTableBy, orderAscending)}>
            <Button variant="link" onClick={() => onSortTable(LASTNAME)}>
              <FormattedMessage id="user.management.table.lastname" />
              {SurveyUtils.sortIcon(LASTNAME, sortUserTableBy, orderAscending)}
            </Button>
          </th>
          <th className={SurveyUtils.addClassForTableHeader("roles.name", sortUserTableBy, orderAscending)}>
            <Button variant="link" onClick={() => onSortTable("roles.name")}>
              <FormattedMessage id="user.management.table.roles" />
              {SurveyUtils.sortIcon("roles.name", sortUserTableBy, orderAscending)}
            </Button>
          </th>
          <th className={SurveyUtils.addClassForTableHeader("roles.name", sortUserTableBy, orderAscending)}>
            <Button variant="link" onClick={() => onSortTable("roles.name")}>
              <FormattedMessage id="user.management.table.units" />
              {SurveyUtils.sortIcon("roles.name", sortUserTableBy, orderAscending)}
            </Button>
          </th>
          <th className={SurveyUtils.addClassForTableHeader(ACTIVE + "_", sortUserTableBy, orderAscending)}>
            <Button variant="link" onClick={() => onSortTable(ACTIVE + "_")}>
              <FormattedMessage id="user.management.table.active" />
              {SurveyUtils.sortIcon(ACTIVE + "_", sortUserTableBy, orderAscending)}
            </Button>
          </th>
          <Visibility roles={[USER_EDITOR]} as="th" className="actions">
            <FormattedMessage id="app.common.title.actions" />
          </Visibility>
        </tr>
      </thead>
      <tbody>
        {useMemo(
          () =>
            users.map((user, i) => (
              <UserManagementTableRow
                key={i}
                user={user}
                userParticipations={usersParticipations[user.username]}
                sortUserTableBy={sortUserTableBy}
                prepareUserDataForEditing={prepareUserDataForEditing}
                propertyChange={propertyChange}
                sendUserAccountNotification={sendUserAccountNotification}
                locale={locale}
              />
            )),
          [
            users,
            usersParticipations,
            sortUserTableBy,
            prepareUserDataForEditing,
            propertyChange,
            sendUserAccountNotification,
            locale
          ]
        )}
      </tbody>
    </BootstrapTable>
  );
};

//sorting the table by given column

UserManagementTable.propTypes = {
  users: PropTypes.array,
  usersParticipations: PropTypes.object,
  sortUserTableBy: PropTypes.string,
  sortUserTableOrder: PropTypes.string,
  locale: PropTypes.string,
  loadUsers: PropTypes.func,
  onSort: PropTypes.func,
  propertyChange: PropTypes.func,
  prepareUserDataForEditing: PropTypes.func,
  changeSortingProperties: PropTypes.func,
  sendUserAccountNotification: PropTypes.func.isRequired
};

export default UserManagementTable;
